// src/features/dashboard/components/EmployeeCompliance/ComplianceHeatmap.tsx

import { useState } from "react";

import {
  ComplianceHeatmapCell,
  ComplianceHeatmapRow,
} from "../../types/Employee/employeeCompliance.types";

interface Props {
  data: ComplianceHeatmapRow[];
  period: string;
  subtitle: string;
}

const ComplianceHeatmap = ({
  data,
  period,
  subtitle,
}: Props) => {
  const [hovered, setHovered] = useState<{
    gate: string;
    day: number;
    status: string;
  } | null>(null);

  console.log("LongPeriodheatmap",period);

  const [activeLegend, setActiveLegend] = useState<"Met" | "Missed" | null>(null);

  return (
  <div
  className="
    relative
    rounded-xl
    border
    border-[#D9DEE8]
    bg-white
    px-5
    pt-12
    pb-4
    overflow-visible
  "
>
      {/* Header */}

      <div className="mb-8 flex items-center justify-between">

        <div className="flex items-center gap-3">

          <h3 className="text-[16px] font-semibold text-[#002B5B]">
            Monthly Compliance Scorecard
          </h3>

          <div
            className="
          rounded-full
          bg-[#EAF2FF]
          px-3
          py-[4px]
          text-[11px]
          font-medium
          text-[#2563EB]
          "
          >
            {period} · {subtitle}
          </div>

        </div>

        <div />

      </div>

      {/* Legend */}

      <div className="mb-5 flex justify-center gap-5">

  <div
    className="flex cursor-pointer items-center gap-2"
    onMouseEnter={() => setActiveLegend("Missed")}
    onMouseLeave={() => setActiveLegend(null)}
  >
    <span
      className="h-3 w-3 rounded-[3px]"
      style={{
        backgroundColor: "#FDE8E8",
        opacity:
          activeLegend === null || activeLegend === "Missed"
            ? 1
            : 0.25,
      }}
    />

    <span
      className="text-[12px]"
      style={{
        opacity:
          activeLegend === null || activeLegend === "Missed"
            ? 1
            : 0.4,
      }}
    >
      Missed
    </span>
  </div>

  <div
    className="flex cursor-pointer items-center gap-2"
    onMouseEnter={() => setActiveLegend("Met")}
    onMouseLeave={() => setActiveLegend(null)}
  >
    <span
      className="h-3 w-3 rounded-[3px]"
      style={{
        backgroundColor: "#CFF7DB",
        opacity:
          activeLegend === null || activeLegend === "Met"
            ? 1
            : 0.25,
      }}
    />

    <span
      className="text-[12px]"
      style={{
        opacity:
          activeLegend === null || activeLegend === "Met"
            ? 1
            : 0.4,
      }}
    >
      Met
    </span>
  </div>

</div>

      {/* Heatmap */}

{/* Heatmap */}
<div className="overflow-x-auto pt-10">
  <div
    className="grid items-center gap-y-2"
    style={{
      gridTemplateColumns: `70px repeat(${data[0]?.days.length ?? 0}, 46px)`,
    }}
  >
    {data.map((row) => (
      <>
        {/* Row Label */}
        <div
          key={`${row.gate}-label`}
          className="pr-3 text-right text-[13px] font-medium text-[#334155]"
        >
          {row.gate}
        </div>

        {/* Cells */}
        {row.days.map((cell) => (
          <div
            key={`${row.gate}-${cell.day}`}
            className="relative flex justify-center"
            onMouseEnter={() =>
              setHovered({
                gate: row.gate,
                day: cell.day,
                status: cell.status,
              })
            }
            onMouseLeave={() => setHovered(null)}
          >
            <div
              className="h-6 w-11 rounded-[4px] border border-white transition-all"
             style={{
  backgroundColor:
    cell.status === "Met"
      ? "#CFF7DB"
      : "#FDE8E8",

  opacity:
    activeLegend === null
      ? 1
      : activeLegend === cell.status
      ? 1
      : 0.25,
}}
            />

           {hovered?.gate === row.gate &&
  hovered.day === cell.day && (
    <div
      className={`absolute z-20 rounded-md bg-[#344054] px-3 py-2 text-[11px] text-white shadow-lg whitespace-nowrap ${
        row.gate === "Login"
          ? "top-8"
          : "-top-12"
      }`}
    >
                  <div>{row.gate}</div>
                  <div>Day {cell.day}</div>
                  <div>{cell.status}</div>
                </div>
              )}
          </div>
        ))}
      </>
    ))}
  </div>

  {/* Bottom Day Labels */}
  <div
    className="mt-3 grid"
    style={{
      gridTemplateColumns: `70px repeat(${data[0]?.days.length ?? 0}, 46px)`,
    }}
  >
    <div />

    {data[0]?.days.map((cell) => (
      <div
        key={cell.day}
        className="text-center text-[12px] text-[#475467]"
      >
        D{cell.day}
      </div>
    ))}
  </div>
</div>


    </div>
  );
};

export default ComplianceHeatmap;